import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, SimpleListAdapter, TS_DropDown, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { BuilderExpressionTypes, DeltaTypes, Expression_OutputTypes, SampleIndex_All, SingleAtomLogics, } from '@app/hcs-shared';
import { _keys, reduceToMap } from '@nu-art/ts-common';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { ModuleFE_Expression } from './ModuleFE_Expression.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const RenderLabels = reduceToMap(BuilderExpressionTypes, (type) => type.dbKey, (type) => type.label);
const ExpressionTypesAdapter = SimpleListAdapter(_keys(RenderLabels), (item) => _jsx(_Fragment, { children: RenderLabels[item.item] }));
const mandatoryProps_expressionType = {
    adapter: ExpressionTypesAdapter,
    placeholder: 'Select Expression Type',
    caret: DropDown_DefaultCaret
};
export const DropDown_ExpressionType = TS_DropDown.prepareEditable(mandatoryProps_expressionType);
const outputTypeAdapter = SimpleListAdapter(Expression_OutputTypes, (item) => _jsx(_Fragment, { children: item.item }));
const mandatoryProps_outputType = {
    placeholder: 'Select output type',
    caret: DropDown_DefaultCaret,
    adapter: outputTypeAdapter
};
export const DropDown_ExpressionOutputTypes = TS_DropDown.prepare(mandatoryProps_outputType);
const mandatoryProps_SampleIndex = {
    adapter: SimpleListAdapter(SampleIndex_All, item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'Select Test Sample',
    caret: DropDown_DefaultCaret,
    className: 'sample-index-dropdown'
};
export const DropDown_SampleIndex = TS_DropDown.prepare(mandatoryProps_SampleIndex);
export const Props_ExpressionDropdown = {
    module: ModuleFE_Expression,
    modules: [ModuleFE_Expression],
    mapper: item => [item.label],
    placeholder: 'Choose an Expression',
    renderer: item => _jsx(_Fragment, { children: item.label }),
    caret: DropDown_DefaultCaret,
};
export const DropDown_Expression = GenericDropDownV3.prepare(Props_ExpressionDropdown);
export const Props_DeltaTypesDropdown = {
    caret: DropDown_DefaultCaret,
    adapter: SimpleListAdapter(DeltaTypes, item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'Delta Type',
    className: 'operator-dropdown'
};
export const DropDown_DeltaTypes = TS_DropDown.prepare(Props_DeltaTypesDropdown);
export const Props_SingleAtomTermLogic = {
    caret: DropDown_DefaultCaret,
    adapter: SimpleListAdapter(SingleAtomLogics, item => _jsx(_Fragment, { children: item.item })),
    placeholder: 'Term Logic',
};
export const DropDown_SingleAtomLogics = TS_DropDown.prepare(Props_SingleAtomTermLogic);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_Expression,
    itemRenderer: (item, onDelete, disabled) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [!disabled && _jsx(ICONS.x.component, { onClick: onDelete }), item.label] });
    },
    uiSelector: DropDown_Expression.selectable,
});
export const MultiSelect_Expression = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map